import LoadingManager from "../../common/loading/LoadingManager";

const COMPONENT_MAPPING_LOADING_PREFIX = "component-mapping-loading";

const getComponentMappingLoadingKey = (correlationId: string) => `${COMPONENT_MAPPING_LOADING_PREFIX}-${correlationId}`;

export const startComponentMappingLoading = (correlationId: string) => {
  LoadingManager.create(getComponentMappingLoadingKey(correlationId));
};

export const stopComponentMappingLoading = (correlationId: string) => {
  LoadingManager.remove(getComponentMappingLoadingKey(correlationId));
};
